import React from 'react';

export function getDisclosureContent(admin) {
    const adminEmployer = (admin && admin.employer) || 'GreenLight Workforce Solutions';
    return (
        <div>
            <h4>Disclosure Regarding Background Investigation</h4>
            <p>
                <span className="custom-text">
                    {adminEmployer} (the “Company”) may obtain information about you from a third party consumer reporting agency for employment purposes. Thus,
                    you may be the subject of a “consumer report” which may include information about your character, general reputation, personal
                    characteristics, and/or mode of living. These reports may contain information regarding your credit history, criminal history, motor vehicle
                    records (“driving records”), verification of your education or employment history, or other background checks.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    You have the right, upon written request made within a reasonable time, to request whether a consumer report has been run about you and to
                    request a copy of your report. These searches will be conducted by{' '}
                    <strong>
                        Checkr, Inc., One Montgomery Street, Suite 2000, San Francisco, CA 94104 | (844) 824-3257 |{' '}
                        <a href="https://checkr.com/applicant" target="_blank" rel="noopener noreferrer">
                            https://checkr.com/applicant
                        </a>.
                    </strong>
                </span>
            </p>
        </div>
    );
}

export function getCaliforniaDisclosure(admin) {
    const adminEmployer = (admin && admin.employer) || 'GreenLight Workforce Solutions';
    return (
        <div>
            <p>
                <span className="custom-text">
                    <strong>NOTICE REGARDING BACKGROUND CHECKS PER CALIFORNIA LAW</strong>
                </span>
            </p>
            <p>
                <span className="custom-text">
                    {adminEmployer} (the “Company”) intends to obtain information about you for employment screening purposes from a consumer reporting agency.
                    Thus, you can expect to be the subject of an “investigative consumer report” and a “consumer credit report” obtained for employment
                    purposes. Such reports may include information about your character, general reputation, personal characteristics and mode of living. With
                    respect to any investigative consumer report from an investigative consumer reporting agency (“ICRA”), the Company may investigate the
                    information contained in your employment application and other background information about you, including but not limited to obtaining a
                    criminal record report, verifying references, work history, your social security number, your educational achievements, licensure, and
                    certifications, your driving record, and other information about you, and interviewing people who are knowledgeable about you. The results
                    of this report may be used as a factor in making employment decisions. The source of any investigative consumer report (as that term is
                    defined under California law) will be{' '}
                    <strong>
                        Checkr, Inc., One Montgomery Street, Suite 2000, San Francisco, CA 94104 | (844) 824-3257 |
                        <a href="https://checkr.com/applicant" target="_blank" rel="noopener noreferrer">
                            https://checkr.com/applicant
                        </a>.
                    </strong>{' '}
                    The Company agrees to provide you with a copy of an investigative consumer report when required to do so under California law.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    Under California Civil Code section 1786.22, you are entitled to find out what is in the CRA’s file on you with proper identification, as
                    follows:
                </span>
            </p>
            <ul>
                <li>
                    <span className="custom-text">
                        In person, by visual inspection of your file during normal business hours and on reasonable notice. You also may request a copy of the
                        information in person. The CRA may not charge you more than the actual copying costs for providing you with a copy of your file.
                    </span>
                </li>
                <li>
                    <span className="custom-text">
                        A summary of all information contained in the CRA file on you that is required to be provided by the California Civil Code will be
                        provided to you via telephone, if you have made a written request, with proper identification, for telephone disclosure, and the toll
                        charge, if any, for the telephone call is prepaid by or charged directly to you.
                    </span>
                </li>
                <li>
                    <span className="custom-text">
                        By requesting a copy be sent to a specified addressee by certified mail. CRAs complying with requests for certified mailings shall not
                        be liable for disclosures to third parties caused by mishandling of mail after such mailings leave the CRAs.
                    </span>
                </li>
            </ul>
            <p>
                <span className="custom-text">
                    “Proper Identification” includes documents such as a valid driver’s license, social security account number, military identification card,
                    and credit cards. Only if you cannot identify yourself with such information may the CRA require additional information concerning your
                    employment and personal or family history in order to verify your identity.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    The CRA will provide trained personnel to explain any information furnished to you and will provide a written explanation of any coded
                    information contained in files maintained on you. This written explanation will be provided whenever a file is provided to you for visual
                    inspection. You may be accompanied by one other person of your choosing, who must furnish reasonable identification. An CRA may require you
                    to furnish a written statement granting permission to the CRA to discuss your file in such person’s presence.
                </span>
            </p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/assets/disclosure.jsx